
import React from "react";
import { Control } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { Info } from "lucide-react";
import { WaitlistFormValues } from "../schema";

interface SectionProps {
  control: Control<WaitlistFormValues>;
}

export function AdditionalInformationSection({ control }: SectionProps) {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-grandpal-beige">
      <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
        <Info className="h-5 w-5 text-grandpal-green" />
        Additional Information
      </h3>
      
      <FormField
        control={control}
        name="additionalInformation"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Is there anything else we should know?</FormLabel>
            <FormControl>
              <Textarea 
                placeholder="Add any other relevant information that might help us find the right nursing home..."
                className="min-h-32"
                {...field} 
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
